import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from  '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/Global-Services/common.service';
import { AppTokenHandler, HTTPStatus } from 'src/app/Global-Services/app-token-handler';
import { HttpErrorResponse } from '@angular/common/http';
import { GlobalVariable } from 'src/app/Variable/global-variable';

export interface DialogData {
  FTERecord: any;
  CurrUserGPN: string;
}


@Component({
  selector: 'app-pop-up-return-record-status-change',
  standalone: false,
  templateUrl: './pop-up-return-record-status-change.component.html',
  styleUrl: './pop-up-return-record-status-change.component.css'
})
export class PopUpReturnRecordStatusChangeComponent implements OnInit {

 ErrorMessage =  [];
  CurrentUserGPN: string ="";
  ReturnReason: string = "";
  constructor(public dialogRef: MatDialogRef<PopUpReturnRecordStatusChangeComponent>, private _router: Router,
    private gservice: CommonService, private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public _data: DialogData, private status: HTTPStatus,
  private gVariable: GlobalVariable) { }

  ngOnInit() {
    this.CurrentUserGPN = this.gVariable.User.UserGPN;
  }


  closeDialog() {
    this.dialog.closeAll();
  }


  UpdateStatusChange() {

    this.ErrorMessage = [];

     if(this.ReturnReason == null || this.ReturnReason == "")
    {
      this.ErrorMessage.push({ message: 'Please enter reason.' });
    }

    if (this.ErrorMessage.length > 0) {
      return;
    }

const param = {
    'ID': this._data.FTERecord.ID,
    'ReturnReason': this.ReturnReason,
    'CurrentUserGPN': this.CurrentUserGPN
    }

    this.gservice.PostDataWithParam('FTEDetails/UpdateStatusChange', param).subscribe(data => {
      if(data != null && data != "" && data.toLowerCase() != "success")
      {
        alert(data);
        return;
      }
      alert("Status of record has been change to ‘Pending with SLHR’. ");
      this.closeDialog();
      this._router.navigate(['/INFTE/home']);
    },
    );
  }
}
